import { environmentStore } from '../states';

export class EnvironmentUtils {
  static getCurrentEnvironment() {
    return environmentStore.getState().environment;
  }
}
